// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgageType.proto

export enum ENUM_MortgageType {
  MORTGAGE_TYPE_UNSPECIFIED = 'MORTGAGE_TYPE_UNSPECIFIED',
  MORTGAGE_TYPE_RESIDENTIAL = 'MORTGAGE_TYPE_RESIDENTIAL',
  MORTGAGE_TYPE_BUY_TO_LET = 'MORTGAGE_TYPE_BUY_TO_LET',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
